module.exports = __webpack_public_path__ + "static/img/Miguel-Arana-Catania.a5ae20a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/speakers/photo/Miguel-Arana-Catania.jpg
// module id = 606
// module chunks = 1